import {
    Button,
    Card,
    theme,
    Typography,
} from "antd";
import {
    CloseOutlined,
    DownloadOutlined,
} from "@ant-design/icons";
import React, {useCallback, useEffect, useState} from "react";
import {
    createCatalogIntegration,
    deleteCatalogIntegration,
    getCatalogIntegration
} from "../../services/catalog-integration";

import { toast } from 'sonner'
export function CatalogIntegration({icon, label, description, assistantID}) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [buttonLoading, setButtonLoading] = useState(false);

    const {
        token: {colorPrimary},
    } = theme.useToken();

    useEffect(() => {
        setLoading(true)
        getCatalogIntegration(assistantID).then(({data}) => {
            if (data.length === 0)
                return

            setData(data[0])
        }).catch((error) => {
            console.log(error)
            toast.error("Erro ao buscar integração de catalogo.");
        }).finally(() => {
            setLoading(false)
        });
    }, [assistantID]);

    const install = useCallback(() => {
        setButtonLoading(true)
        createCatalogIntegration(assistantID).then(({data}) => {
            setData(data);
        }).catch((error) => {
            console.log(error);
            toast.error("Erro ao instalar integração de catálogo.");
        }).finally(() => {
            setButtonLoading(false);
        });
    }, [assistantID]);

    const uninstall = useCallback(() => {
        setButtonLoading(true);
        deleteCatalogIntegration(assistantID, data.id).then(() => {
            setData(undefined);
        }).catch((error) => {
            console.log(error);
            toast.error("Erro ao remover integração de catálogo.");
        }).finally(() => {
            setButtonLoading(false)
        });
    }, [data]);

    return (
        <>
            <Card
                loading={loading}
                title={<Typography.Title level={5} ellipsis={{tooltip: label}}>{icon} {label}</Typography.Title>}
                extra={<Button type={data ? 'default' : 'primary'}
                               loading={loading || buttonLoading}
                               danger={!!data}
                               onClick={() => data ? uninstall() : install()}
                               icon={data ? <CloseOutlined/> : <DownloadOutlined/>}
                >{loading ? undefined : data ? 'Remover' : 'Instalar'}</Button>}>
                {description}
            </Card>
        </>
    )
}
